// src/admin/components/AdminPagination.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { COLORS, FONT_MONO, FONT_SANS, RADII } from '../../constants/theme.js';

export default function AdminPagination({ total, limit, offset, onChange, itemLabel }) {
  const { t } = useTranslation('admin');
  const totalPages = Math.ceil(total / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  if (totalPages <= 1) return null;

  const btnStyle = (disabled) => ({
    padding: '6px 10px', borderRadius: RADII.controlInner,
    border: `1px solid ${COLORS.borderStrong}`,
    background: disabled ? COLORS.field : COLORS.surface,
    color: disabled ? COLORS.textTertiary : COLORS.ink,
    cursor: disabled ? 'not-allowed' : 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: '4px',
    fontSize: '12px', fontFamily: FONT_SANS,
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0' }}>
      <span style={{ fontSize: '12px', color: COLORS.textSecondary }}>
        {itemLabel
          ? t('pagination.itemsTotal', { n: total, item: itemLabel })
          : t('pagination.usersTotal', { count: total })}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <button
          disabled={currentPage <= 1}
          onClick={() => onChange(Math.max(0, offset - limit))}
          style={btnStyle(currentPage <= 1)}
        >
          <ChevronLeft size={14} /> {t('pagination.prev')}
        </button>
        <span style={{ fontSize: '12px', color: COLORS.ink, fontFamily: FONT_MONO }}>
          {currentPage} / {totalPages}
        </span>
        <button
          disabled={currentPage >= totalPages}
          onClick={() => onChange(offset + limit)}
          style={btnStyle(currentPage >= totalPages)}
        >
          {t('pagination.next')} <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
